import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/imgcaptions/piceBox.png'
import _imports_1 from '@/assets/imgcaptions/icon_tianjiasel.png'
import _imports_2 from '@/assets/imgcaptions/icon_shangchuanS.svg'
import _imports_3 from '@/assets/imgcaptions/icon_filezip.svg'


const _hoisted_1 = { class: "upSrtBoxInner" }
const _hoisted_2 = { class: "upSrtTitle" }
const _hoisted_3 = { class: "upSrtPrompt" }
const _hoisted_4 = { class: "aiTextBoxTop" }
const _hoisted_5 = { class: "aiTextBoxTop" }
const _hoisted_6 = { class: "aiTextBoxTopInput" }
const _hoisted_7 = { class: "aiTextBoxTop" }
const _hoisted_8 = { class: "typeList" }
const _hoisted_9 = { class: "showThis" }
const _hoisted_10 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = { class: "showThis" }
const _hoisted_12 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_13 = { class: "aiTextBoxTopSrt" }
const _hoisted_14 = { class: "captionsFileIconBox" }
const _hoisted_15 = {
  key: 0,
  class: "iconBox"
}
const _hoisted_16 = { class: "iconInnerTextExample" }
const _hoisted_17 = {
  key: 1,
  class: "uploadBoxShow"
}
const _hoisted_18 = { class: "uploadBoxShowInner" }
const _hoisted_19 = { class: "upSrtBtn" }
const _hoisted_20 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue';
import { languageList,styleList} from "./icon.ts";
import FetchRequest from "@/api/FetchRequest";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import Auth from "@/api/Auth";

export default /*@__PURE__*/_defineComponent({
  __name: 'uploadSrt',
  props: {
    languagefrom:String,
    id:Number,
},
  emits: ['closeThis','reshowSrtText'],
  setup(__props, { emit: __emit }) {

const props = __props
const showFrom=ref(false)
onMounted(()=>{
    console.log(props.languagefrom)
   
    if(props.languagefrom==undefined||props.languagefrom==''){
        showFrom.value=true
    }
})
const emit = __emit
// srt文件格式
const srtType=ref('cn')
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
// 上传文件
const fileSrt=ref()
const covers=ref(false)
const version=ref('')
const upState=ref(false)
const srttitle=ref('')
const srtChange=(file: any,)=>{
    console.log(file)
    const isLtM = file.raw.size / 1024 / 1024;
    if (isLtM > 10) {
        ElMessage.error("请上传10M以内的文件!");
        return 
    }
    srttitle.value=file.name
    upState.value=true
    fileSrt.value = file.raw
}
// 上传srt字幕
const handleClose = () => {
    console.log('上传srt字幕')
    if(version.value==''||fileSrt.value==null){
        ElMessage({
                    type: 'info',
                    message: '请完善上传信息',
                })
        return
    }
    const formDatas = new FormData();
    formDatas.append('cover', covers.value);
    formDatas.append('version', version.value);
    formDatas.append('srtFile', fileSrt.value);
    formDatas.append('originalTextId', props.id);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + Auth.getToken(),
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };
    console.log(FetchRequest.getHost())
    fetch(FetchRequest.getHost() + '/ai/subtitle/text/srt', option)
        .then(function (response) {
            console.log(response);
            if (response.status == 200) {
                // dialogVisible.value=false
                // emit('regetRole')
                return response.json()
            }
        }).then(function (data) {

           
            if (data.code == 200) {
                console.log(data);
                ElMessage({
                    type: 'success',
                    message: '上传成功',
                })
                emit('reshowSrtText')
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
        })
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: "upSrtBox",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "上传字幕", -1)),
        _createElementVNode("span", {
          class: "closeBtn",
          onClick: _withModifiers(closeBox, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((covers).value = $event)),
            class: "selectVers"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("option", { value: "false" }, "发布为新版本", -1),
            _createElementVNode("option", { value: "true" }, "替换当前版本", -1)
          ]), 512), [
            [_vModelSelect, covers.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "aiTextBoxTopTitle" }, "版本名称", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "请输入版本名称",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((version).value = $event))
            }, null, 512), [
              [_vModelText, version.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "aiTextBoxTopTitle" }, "SRT文件内容格式", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (srtType.value='cn'), ["stop"]))
              }, null, 512), [
                [_vShow, srtType.value!='cn']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                [_vShow, srtType.value=='cn']
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "原文", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (srtType.value='cnOren'), ["stop"]))
              }, null, 512), [
                [_vShow, srtType.value=='cn']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                [_vShow, srtType.value=='cnOren']
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "原文+译文", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_upload, {
              class: "upload-demo",
              drag: "",
              "show-file-list": false,
              multiple: "",
              "auto-upload": false,
              "on-change": srtChange,
              style: {"width":"100%","height":"100%"},
              ref: "srtRef ",
              accept: ".srt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (!upState.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "iconInner" }, [
                          _createElementVNode("img", { src: _imports_2 })
                        ], -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "iconInnerText" }, " 点击或拖拽字幕文件上传 ", -1)),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "格式示例:", -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "00:00:05,250 --> 00:00:06,640", -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "5月6日", -1)),
                          _withDirectives(_createElementVNode("span", null, "May 6th.", 512), [
                            [_vShow, srtType.value=='cnOren']
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (upState.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[15] || (_cache[15] = _createElementVNode("img", { src: _imports_3 }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(srttitle.value), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", {
              class: "btnNo",
              onClick: _withModifiers(closeBox, ["stop"])
            }, "取消"),
            _createElementVNode("span", {
              class: "btnOk",
              onClick: _withModifiers(handleClose, ["stop"])
            }, "确定")
          ])
        ])
      ])
    ])
  ]))
}
}

})